export {
  getVirtualComponentList,
  getVCompModelText,
  getVCompModelPinList,
  getVCSignalName,
  getVCDefaultModel,
  N_PORT,
  VC_RLC_TYPES,
  VC_SHUNT_TYPES,
  SHUNT_R,
  SHUNT_L,
  SHUNT_C,
  VC_CAPS,
  updateViewVComps,
  updateViewVCompsPanel,
  getShuntRLCType
} from './virtualCompHelper';